import { ReactElement, ReactNode, useState } from 'react';

import { TABLET_MAX_WIDTH } from '../AppConstants';
import { User } from '../types/User';
import Header from './AppHeader/Header';
import SideNav from './SideNav';

import '../styles/components/Layout.less';

interface Props {
    mainContent: ReactNode;
    currentUser?: User;
    loadingUser?: boolean;
}

const Layout = ({ mainContent, currentUser, loadingUser }: Props): ReactElement => {
    const [sideNavToggled, setSideNavToggled] = useState(window.innerWidth > TABLET_MAX_WIDTH);

    const resizeMainContent = (sidebarToggled: boolean) => {
        setSideNavToggled(sidebarToggled);
    };

    return (
        <>
            <Header currentUser={currentUser} environment={import.meta.env.VITE_SCANNING_VERSION_SUFFIX} />
            <SideNav sideNavToggled={resizeMainContent} currentUser={currentUser} loadingUser={loadingUser} />
            <div className={`main-content${!sideNavToggled ? ' sidebar-hidden' : ''}`}>{mainContent}</div>
        </>
    );
};

export default Layout;
